import 'css-chunksrc/client/scenes/preferences/profile/styles.scss';export default {
  "profile": "_profile_1p7is_1",
  "row": "_row_1p7is_8",
  "fileInput": "_fileInput_1p7is_17",
  "name": "_name_1p7is_21",
  "group": "_group_1p7is_26",
  "subTitle": "_subTitle_1p7is_30",
  "text": "_text_1p7is_35",
  "tagList": "_tagList_1p7is_43",
  "tags": "_tags_1p7is_53",
  "tag": "_tag_1p7is_43"
};